// Function to update logo based on theme
function updateLogoByTheme() {
    const logoImg = document.querySelector('.ss-logo-img');
    if (!logoImg) return;

    const isLightTheme = document.body.classList.contains('light') || document.body.classList.contains('cb-light');
    logoImg.src = isLightTheme
        ? './desktop_assets/header/white.gif'
        : './desktop_assets/header/black.gif';
}

// Initialize logo on page load
document.addEventListener("DOMContentLoaded", function () {
    // Update logo based on initial theme
    updateLogoByTheme();

    // Watch for theme changes via class changes on body
    const themeObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                updateLogoByTheme();
            }
        });
    });

    // Start observing body for class changes
    if (document.body) {
        themeObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
})